import { ApiError, getJson, postJson } from '../util/fetch-json.js';
import { auth } from '../state/app-state.js';

export async function checkAuth(): Promise<boolean> {
  try { await getJson('/api/auth/check'); return true; }
  catch { return false; }
}

export function renderLoginScreen(root: HTMLElement, onSuccess: () => void): void {
  root.innerHTML = `
    <div class="login-shell">
      <form class="login-card" novalidate>
        <h1>SGT Signage Demo</h1>
        <label for="u">Username</label>
        <input id="u" name="username" autocomplete="username" required />
        <label for="p">Password</label>
        <input id="p" name="password" type="password" autocomplete="current-password" required />
        <button type="submit">Sign in</button>
        <div class="login-error" role="alert"></div>
      </form>
    </div>`;
  const form = root.querySelector('form')!;
  const err = root.querySelector('.login-error') as HTMLElement;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    err.textContent = '';
    const username = (form.elements.namedItem('username') as HTMLInputElement).value.trim();
    const password = (form.elements.namedItem('password') as HTMLInputElement).value;
    try {
      await postJson('/api/login', { username, password });
      auth.set('authed');
      onSuccess();
    } catch (e2) {
      err.textContent = e2 instanceof ApiError ? e2.message : 'Login failed';
    }
  });
}
